import styled from "@emotion/styled";

import Icon from "shared/components/Icon";
import Tile from "shared/components/Tile";
import { COLORS } from "shared/config/constants";

const TileCustom = styled(Tile)`
  .tile-header {
    align-items: center;
  }
  .tile-header-title-container {
    width: 100%;
    > div,
    h2 > div {
      width: 100%;
      align-items: center;
    }
    div {
      font-size: 15px;
      font-weight: 400;
    }
    .main-header-left {
      &.vor {
        width: 100%;
        > div {
          width: 70%;
        }
      }
      .bold {
        font-size: 17px;
        font-weight: 500;
      }
    }
  }
  &.verified {
    background-color: ${COLORS.lightGreen};
  }
  &.warn {
    background-color: ${COLORS.lightOrange};
  }
  &.unverified {
    background-color: ${COLORS.well.backgroundLightError};
  }
`;

const SubTileCustom = styled(Tile)`
  .tile-header-title-container h2 {
    font-size: 15px;
    font-weight: 400;
  }
`;

const PersonIcon = styled(Icon.PersonIcon)`
  width: 24px;
  height: 24px;
  margin-right: 11px;
`;

const VerifiedIcon = styled(Icon.CheckIcon)`
  width: 16px;
  height: 16px;
  margin-right: 10px;
`;

const FailedIcon = styled(Icon.ErrorTriangleIcon)`
  width: 16px;
  height: 16px;
  margin-right: 10px;
`;

const Details = styled.span<{ bold?: boolean }>`
  font-size: 15px;
  font-weight: ${(props) => props.bold && 400};
`;

const VerificationContainer = styled(Tile.Inner)`
  background-color: ${COLORS.lightGray2};
  padding: 0px;
`;

const SentilinkHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const SentilinkSubtitle = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: ${COLORS.grayTheme?.textColor || COLORS.textColorSecondary};
`;

const SentilinkBadge = styled("span", {
  shouldForwardProp: (prop) => prop !== "background" && prop !== "color",
})<{ background: string; color: string }>`
  flex-shrink: 0;
  margin-left: 12px;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
  background-color: ${(props) => props.background};
  color: ${(props) => props.color};
`;

const SentilinkDetailBody = styled.div`
  padding: 16px 20px;
`;

const SentilinkDetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 10px 0;
`;

const SentilinkDetailLabel = styled.span`
  flex: 0 0 33%;
  max-width: 140px;
  font-size: 14px;
  font-weight: 400;
  color: ${COLORS.grayTheme?.textColor || COLORS.textColorSecondary};
`;

const SentilinkDetailValue = styled("span", {
  shouldForwardProp: (prop) => prop !== "valueColor",
})<{ valueColor?: string }>`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.valueColor || COLORS.textColorPrimary};
`;

const SentilinkDetailDivider = styled.hr`
  margin: 0;
  border: none;
  border-top: 1px dotted ${COLORS.grayTheme?.borderColor || "#d9d9d9"};
`;

const SentilinkNoReasons = styled.div`
  padding-top: 16px;
`;

export {
  TileCustom,
  SubTileCustom,
  PersonIcon,
  VerifiedIcon,
  FailedIcon,
  Details,
  VerificationContainer,
  SentilinkHeaderText,
  SentilinkSubtitle,
  SentilinkBadge,
  SentilinkDetailBody,
  SentilinkDetailRow,
  SentilinkDetailLabel,
  SentilinkDetailValue,
  SentilinkDetailDivider,
  SentilinkNoReasons,
};
